const TOC_CTXINFO_WRAPPER_ID = 'tocContentInfo';
const GITLAB_WIKI_BASE_URL = 'https://gitlab.ibleaders.com/web-service/manuals/ibsheet8/wikis';

export function createTocContentInfoElement() {
  // TOC CONTENT_INFO
  const children = [
    { role: 'addr', text: 'content-url', style: 'info', },
    { role: 'wiki', text: 'WIKI', style: 'primary', },
    { role: 'edit', text: 'EDIT', style: 'success', },
  ].map(item => {
    const { role, text, style } = item;
    return $('<a/>', {
      class: `badge badge-${style}`,
      'data-role': role,
      text
    }).on('click', evt => {
      const target = evt.target;
      const targetRole = target.getAttribute('data-role');
      let url;
      switch (targetRole) {
        case 'wiki': case 'edit':
          url = target.getAttribute('data-url');
          break;
        default:
          return;
      }
      window.open(url);
    });
  });
  const $tocContentInfo = $('<div/>', {
    id: TOC_CTXINFO_WRAPPER_ID,
  }).append(children)
    .appendTo(document.body);
  this.tocInfoElements = {
    wrapper: $tocContentInfo,
    addr: children[0],
    wiki: children[1],
    edit: children[2],
  };
}

export function setTocContentInfo(url) {
  const els = this.tocInfoElements;
  const hash = url.replace(/\.html$/, '');
  const wikiURL = `${GITLAB_WIKI_BASE_URL}/${hash}`;
  els.addr.text(hash).attr('href', `#${hash}`);
  els.wiki.attr('data-url', wikiURL);
  els.edit.attr('data-url', `${wikiURL}/edit`);
}
